import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function getInvoices (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getNotifications)
    })
  } else {
    const req = {
      url: '/api/facturas/getfacturaspag',
      method: 'POST',
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { getInvoices }
